import { render, staticRenderFns } from "./OrdersApi.vue?vue&type=template&id=8437fe82&scoped=true&"
import script from "./OrdersApi.vue?vue&type=script&lang=js&"
export * from "./OrdersApi.vue?vue&type=script&lang=js&"
import style0 from "./OrdersApi.vue?vue&type=style&index=0&id=8437fe82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8437fe82",
  null
  
)

export default component.exports